//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "platformServiceAgreement"
}



// WEBPACK FOOTER //
// ./src/pages/agreement/enterpriseEnterInPolicy.vue